import type { ReadConfig } from 'api-read-hook';

import { useApiRead } from 'api-read-hook';

import * as Company from './Company';
import * as Upload from './Upload';
import * as User from './User';

export type V = {
  '@id': string;
  '@type': 'CompanyWishlist';
  company: Company.BaseView;
  ideas: Array<{
    '@id': string;
    '@type': 'WishlistIdea';
    id: string;
    title: string;
    body: string | null;
    uploads: Array<Upload.BaseView>;
    state: string;
    serviceOrder: {
      '@id': string;
      '@type': 'ServiceOrder';
      name: string;
      referenceNumber: string | null;
      ideaIds: Array<string>;
      status: string;
    } | null;
    position: number;
    author: User.BaseView | null;
    createdAt: string;
    commentCount: number | null;
  }>;
  serviceOrders: Array<{
    '@id': string;
    '@type': 'ServiceOrder';
    name: string;
    referenceNumber: string | null;
    ideaIds: Array<string>;
    status: string;
  }>;
};

export function useReadItemWishlist(id: string, options?: ReadConfig) {
  return useApiRead<V>(`/companies/${id}/wishlist`, options);
}
